export default function ValidateEmail(email) {
  const elm = document.createElement('input')
  elm.value = email
  elm.required = true
  elm.type = 'email'

  return elm.checkValidity()
}
